import { render, staticRenderFns } from "./app-data-table.vue?vue&type=template&id=3de29879&scoped=true&"
import script from "./app-data-table.vue?vue&type=script&lang=js&"
export * from "./app-data-table.vue?vue&type=script&lang=js&"
import style0 from "./app-data-table.vue?vue&type=style&index=0&id=3de29879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de29879",
  null
  
)

export default component.exports